import React from 'react'
import DataGrid, {
  ColumnChooser,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Export,
  Selection,
  SearchPanel,
  Pager,
  Paging,
} from "devextreme-react/data-grid";
import { TrafficOutlined } from '@mui/icons-material';
import { Row } from 'devextreme-react/responsive-box';

export const LVGridDetalle = (props) => {
  const { dataSource, id, children, Titulo, PageSize = 5 } = props;

  return (

    <div className="master-detail-caption">
      <b>{Titulo}</b>

      <DataGrid
        dataSource={dataSource}
        style={{ fontSize: '10px', fontFamily: 'Tahoma, sans-serif' }}
        showRowLines={true}
        showBorders={true}
        allowColumnResizing={true}
        id={id}
        rowAlternationEnabled={true}
      >
        <HeaderFilter visible={false} />
        <FilterPanel visible={false} />
        <FilterRow visible={false} />
        <Export enabled={true} allowExportSelectedData={false} />
        <SearchPanel visible={false} />

        <ColumnChooser enabled="True" mode="select" />

        {children}

        <Paging defaultPageSize={PageSize} />
        <Pager
          showPageSizeSelector={false}
        />
      </DataGrid>

    </div>
  );
}